const forms = {
  onRequest: "Pageidaujant", // translated 
  person: "asmuo", // translated 
  travelDate: "Kelionės data", // translated 
  travelDates: "Kelionės datos", // translated 
  cancel: "Atšaukti", // translated 
  getPrice: "Gaukite Kainą", // translated 
};



export default forms;
